import React from 'react';
import { motion } from 'framer-motion';
import { Shield } from 'lucide-react';
export function RealProtection() {
  return <section className="py-14 md:py-20 bg-navy text-white relative overflow-hidden" data-id="element-260">
      {/* Subtle background pattern */}
      <div className="absolute inset-0 opacity-5" style={{
      backgroundImage: 'radial-gradient(#C9A84C 1px, transparent 1px)',
      backgroundSize: '30px 30px'
    }} data-id="element-261"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-262">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="max-w-3xl mx-auto" data-id="element-263">
          <div className="text-center mb-12" data-id="element-264">
            <Shield size={48} className="text-gold mx-auto mb-6" data-id="element-265" />
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-gold" data-id="element-266">
              ASÍ ES COMO SE VE LA PROTECCIÓN REAL
            </h2>
          </div>

          <div className="bg-white/5 backdrop-blur-sm p-8 md:p-12 rounded-2xl border border-white/10 space-y-6 text-lg md:text-xl leading-relaxed" data-id="element-267">
            <p className="font-serif text-2xl italic text-gray-300 mb-8" data-id="element-268">
              Imagina esto:
            </p>

            <p data-id="element-269">
              Tienes un accidente de carro. Es aterrador. Pero a la mañana
              siguiente, tomas el teléfono y llamas a tu agente — no a un número
              1-800. Una persona real que sabe tu nombre. Que conoce tu póliza.
              Que te guía paso a paso en el proceso del reclamo.
            </p>

            <p className="font-bold text-gold text-2xl py-4" data-id="element-270">
              No entras en pánico. No te preguntas si estás cubierto. Ya lo
              sabes. Porque Angel Insurance ya se aseguró de ello.
            </p>

            <div className="pt-6 border-t border-white/20 mt-8 text-center space-y-2" data-id="element-271">
              <p className="text-2xl font-serif" data-id="element-272">
                Esa es la tranquilidad que mereces.
              </p>
              <p className="text-2xl font-serif font-bold text-gold" data-id="element-273">
                Eso es lo que merece tu familia.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}